export const DROPDOWN_FILTERS = [
  { key: 'actionNeeded', label: 'Action Needed', id: 'action-needed' },
  { key: 'advisor', label: 'Advisor Number', id: 'advisor' },
  { key: 'technician', label: 'Technician', id: 'technician', openAbove: true },
]

export const OUTSTANDING_CHECKBOX_FILTERS = [
  { key: 'agesOut', label: 'Ages out in < 7 days', name: 'agesOut' },
  { key: 'noUpdate', label: 'No update in > 5 days', name: 'noUpdate' },
  { key: 'highDollar', label: 'High dollar', name: 'highDollar' },
  { key: 'reopened', label: 'Reopened', name: 'reopened' },
  { key: 'new', label: 'New in last 7 days', name: 'new' },
  { key: 'isOpen', label: 'Open RO', name: 'open' },
  { key: 'isClosed', label: 'Closed RO', name: 'closed' },
]

export const RESOLVED_CHECKBOX_FILTERS = [
  { key: 'agesOut', label: 'Ages out in < 7 days', name: 'agesOut' },
  { key: 'noUpdate', label: 'No update in > 5 days', name: 'noUpdate' },
  { key: 'highDollar', label: 'High dollar', name: 'highDollar' },
  { key: 'new', label: 'New in last 7 days', name: 'new' },
]
